import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactJson from 'react-json-view';

class MeaningMatchScore extends Component {
    constructor() {
        super();
        this.state = {
            successResp: false,
            firstSentence: '',
            secondSentence: '',
            outputJson: '',
            languageVal: { value: '', label: '' },
            showExpandedPopup: false,
            disableExpand: true
        }
        this.languageOptions = [];
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    resetData = () => {
        document.getElementById("firstSentence").value = "";
        document.getElementById("secondSentence").value = "";
        document.getElementById("meaningMatchId").value = "";
    }

    handleLangChange = (e) => {
        this.state.languageVal = { value: e.value, label: e.label }
        this.setState(this.state);
    }

    notifyFailToLoadLanguages() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchLanguagesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var languageController = this;
        $.ajax(
            {
                url: "/api/project-languages-selected",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    languageController.state.successResp = true;
                    if (res.success === true) {
                        var loadedLang = res.result;

                        languageController.setState({ language: loadedLang });
                        var numberOfLanguages = loadedLang.length;
                        var ele3 = document.getElementById("languageIdDropDown");
                        if (ele3 != null) {
                            if (ele3 != "") {
                                ele3.innerHTML = "";
                            }
                            for (var i = 0; i < numberOfLanguages; i++) {
                                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedLang[i]
                                ['code'] + '">' + loadedLang[i]['name'] + '</option>';
                            }
                        }
                    }
                    else {
                        languageController.notifyFailedLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }

    notifyNoLangSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
            position: "top-center"
        });
    }

    notifyNotSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });
    }

    validateFields = () => {
        if (this.state.firstSentence === '' || this.state.secondSentence === '') {
            this.notifyNotSelected();
        } else {
            return true;
        }
    }

    fetchMeaningMatchResultApi = () => {
        var meaningMatchController = this;
        if (meaningMatchController.validateFields()) {
            var language = document.getElementById("languageIdDropDown").value;
            var entailmentType = document.getElementById("entailmentType").value;
            let requestVar = {
                projectId: localStorage.getItem("currentProjectId"),
                firstSentence: meaningMatchController.state.firstSentence,
                secondSentence: meaningMatchController.state.secondSentence,
                language: language,
                entailmentType: entailmentType
            }
            if (localStorage.getItem("runtimeNodeName") != "null") {
                requestVar["runtimeNodeName"] = localStorage.getItem("runtimeNodeName");
            }
            $.ajax({
                url: "/api/test-entailment",
                async: false,
                method: 'GET',
                data: requestVar,
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                success: function (res) {
                    if (res.success === true) {
                        meaningMatchController.state.outputJson = res.result.result;
                        meaningMatchController.state.disableExpand = false;
                        meaningMatchController.setState(meaningMatchController.state);
                    } else {
                        meaningMatchController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }
    }

    componentDidMount() {
        let thisController = this;
        setTimeout(() => {
            this.fetchLanguagesApi();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            if (thisController.isNullOrEmpty(document.getElementById("firstSentence"))) {
                document.getElementById("firstSentence").value = "";
            }
            if (thisController.isNullOrEmpty(document.getElementById("secondSentence"))) {
                document.getElementById("secondSentence").value = "";
            }
            if (thisController.isNullOrEmpty(document.getElementById("meaningMatchId"))) {
                document.getElementById("meaningMatchId").value = "";
            }
            thisController.languageOptions = [];
            thisController.projectId = event.projectId;
            thisController.fetchLanguagesApi(event.projectId);
        })
    }

    isNullOrEmpty(fieldVal) {
        if (fieldVal === "") {
            return false;
        } else if (fieldVal === null) {
            return false;
        } else if (fieldVal === undefined) {
            return false;
        } else {
            return true;
        }
    }

    handleFirstSentence = (e) => {
        this.setState({ firstSentence: e.target.value });
    }

    handleSecondSentence = (e) => {
        this.setState({ secondSentence: e.target.value });
    }

    showExpandedPopupFunc = () => {
        this.state.showExpandedPopup = true;
        this.setState(this.state);
    }

    closeExpandedJsonPopup = () => {
        this.state.showExpandedPopup = false;
        this.setState(this.state);
    }

    render() {
        const yourJSON = this.state.outputJson;
        const copyText = JSON.stringify(yourJSON, null, 4);

        return (
            <div className="wrapper ovrfhide" style={{ height: "800px", background: "#ffffff" }}>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none' }}>
                    <div>
                        {/* for toaster */}
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        {/* for reactTable */}
                        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                        {/* pretty print json css*/}
                        <link rel="stylesheet" href="./assets/css/prettyJson.css" />
                        <link rel="stylesheet" type="text/css" href="./assets/css/widgetOverride.css" />

                        <ToastContainer className="Toast-at-center" />
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <h6 className="taglineTxt"></h6>
                                        <label>Language</label>
                                        <select
                                            id="languageIdDropDown" className="languageIdDropDown"
                                            style={{
                                                width: '50%', height: '30px', borderRadius: '4px',
                                                backgroundColor: '#F9F9FB',
                                                marginLeft: '16px'
                                            }} >

                                        </select>
                                    </div>
                                    <div className="col-sm-6">
                                        <h6 className="taglineTxt"></h6>
                                        <label>Entailment Type</label>
                                        <select
                                            id="entailmentType" className="languageIdDropDown"
                                            style={{
                                                width: '50%', height: '30px', borderRadius: '4px',
                                                backgroundColor: '#F9F9FB',
                                                marginLeft: '16px'
                                            }} >
                                            <option value="normal">Normal</option>
                                            <option value="template">Template</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div><div className="row">
                            <div className="col-md-4" style={{ marginLeft: "3%", marginTop: "20px" }}>
                                <label>First Sentence</label>
                                <div className="card" style={{ borderRadius: '10px' }}>
                                    <textArea style={{ height: "75px", borderRadius: '10px' }} id="firstSentence"
                                        onChange={this.handleFirstSentence} />
                                </div>
                                <label>Second Sentence</label>
                                <div className="card" style={{ borderRadius: '10px' }}>
                                    <textArea style={{ height: "75px", borderRadius: '10px' }} id="secondSentence"
                                        onChange={this.handleSecondSentence} />
                                </div>
                            </div>



                            <div style={{ textAlign: 'center', marginTop: '36px', display: 'grid' }}>
                                <button className="btn2 table-action-button "
                                    style={{
                                        width: '80px', height: '36px', marginLeft: 'auto', marginRight: 'auto',
                                        marginTop: 'auto'
                                    }} onClick={this.fetchMeaningMatchResultApi}>Test</button>

                                <button className="btn2 table-action-button "
                                    title="Reset your input"
                                    style={{ width: '80px', height: '36px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '54px' }} onClick={this.resetData}>
                                    <img src="assets/images/reset.png" />
                                </button>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <label style={{ marginTop: "20px" }}>Meaning Match Result</label>
                                    </div>
                                    <div className="col-sm-6" Align="right">
                                        <CopyToClipboard text={copyText}>
                                            <button className="btn action-button" style={{ marginBottom: "10px" }} title="copy content"><img src="./assets/images/copy.png" /></button>
                                        </CopyToClipboard>
                                        <button className="btn action-button" style={{ marginBottom: "10px" }}
                                            title="Expand content" onClick={this.showExpandedPopupFunc} disabled={this.state.disableExpand}>
                                            <img style={{ width: "23px", height: "25px" }} src="./assets/images/expand.png" />
                                        </button>
                                    </div>
                                </div>


                                <div className="card">
                                    <JSONPretty data={this.state.outputJson}
                                        id="meaningMatchId"
                                        style={{
                                            height: '200px', border: 'none',
                                            overflowY: this.state.outputJson !== '' ? "scroll" : "hidden"
                                        }}></JSONPretty>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" style={{ display: this.state.showExpandedPopup ? 'block' : 'none', marginLeft: "49%", width: "auto" }}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ height: "100%" }}>
                            <div className="modal-header noBorder">
                                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeExpandedJsonPopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        <path d="M0 0h24v24H0z" fill="none" />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal-body">
                                <ReactJson src={this.state.outputJson}
                                    iconStyle="square"
                                    enableClipboard={true}
                                    displayDataTypes={false}
                                    style={{ height: "500px", overflowY: "auto" }} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }

}

export default MeaningMatchScore;



// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/tabsComponent/MeaningMatchScore.js